var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-12c57ac5"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "chat" };
var _hoisted_2 = { class: "chat-header" };
var _hoisted_3 = { class: "min-w-0 chat-header__info header-info" };
var _hoisted_4 = { class: "ml-2" };
var _hoisted_5 = { class: "min-w-0 header-info__text" };
var _hoisted_6 = { class: "header-info__name" };
var _hoisted_7 = { class: "truncate" };
var _hoisted_8 = {
    key: 0,
    class: "header-info__subtitle truncate"
};
var _hoisted_9 = {
    key: 0,
    class: "flex shrink-0 items-center sm:ml-10 lg:mr-8"
};
var _hoisted_10 = { class: "messages" };
var _hoisted_11 = { class: "chat-content__loader" };
var _hoisted_12 = {
    key: 0,
    class: "message-date"
};
var _hoisted_13 = { class: "message-date__body" };
var _hoisted_14 = {
    key: 0,
    class: "chat-editable-message"
};
var _hoisted_15 = { class: "chat-editable-message__text" };
var _hoisted_16 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", { class: "chat-editable-message__title" }, " Редактировать сообщение ", -1); });
var _hoisted_17 = ["textContent"];
var _hoisted_18 = { class: "w-full h-full flex" };
var _hoisted_19 = { class: "chat-footer__attach footer-attach" };
var _hoisted_20 = { class: "flex items-center space-x-2" };
var _hoisted_21 = { class: "flex items-center space-x-2" };
var _hoisted_22 = { class: "flex items-center relative min-h-[54px]" };
var _hoisted_23 = {
    key: 0,
    class: "footer-input__placeholder"
};
var _hoisted_24 = { class: "w-full h-full flex items-center" };
var _hoisted_25 = { class: "ml-5 flex items-center" };
var _hoisted_26 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "animate-pulse w-2.5 h-2.5 bg-red rounded-full mr-4" }, null, -1); });
var _hoisted_27 = { class: "text-[#4D5766] text-lg" };
var _hoisted_28 = { class: "text-[#4D57664D] text-lg flex-[1] h-full w-full relative overflow-hidden" };
var _hoisted_29 = { class: "w-full h-full flex items-center" };
var _hoisted_30 = { class: "ml-5 flex items-center" };
var _hoisted_31 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "animate-pulse w-2.5 h-2.5 bg-red rounded-full mr-4" }, null, -1); });
var _hoisted_32 = { class: "text-[#4D5766] text-lg w-[70px]" };
var _hoisted_33 = { class: "flex-[1] text-center" };
var _hoisted_34 = { class: "w-full h-full flex items-center" };
var _hoisted_35 = { class: "ml-5 mr-4 flex items-center" };
var _hoisted_36 = { class: "flex-[1] text-center w-full h-full flex items-center" };
var _hoisted_37 = { class: "record-track" };
var _hoisted_38 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "bg-white h-[11px] w-[3px] rounded-md" }, null, -1); });
var _hoisted_39 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "bg-white h-[11px] w-[3px] ml-[2px] rounded-md" }, null, -1); });
var _hoisted_40 = { class: "record-countdown" };
var _hoisted_41 = { class: "chat-footer__send-wrapper" };
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { apiErrorsHandle, clone, generateId, generateUuid, placeCaretAtEnd, sleep, } from '@common/utils/Helpers/Helpers';
import Message from './components/Message.vue';
import dayjs from 'dayjs';
import Avatar from '@common/ui/EAvatar/EAvatar.vue';
import Auth from '@common/modules/auth';
import { formatOnline } from '@common/utils/Datetime/Datetime';
import { isMobile, isTouchable } from '@common/utils/Crossbrowser';
import EAudioPlayer from '@common/ui/EAudioPlayer/EAudioPlayer.vue';
import ERecordAudioController from '@common/ui/ERecordAudioController/ERecordAudioController.vue';
import { RecordAudioStopByEnum } from '@common/ui/ERecordAudioController/enums/recordAudioStopBy.enum';
import { useAudioUtils } from '@common/hooks/audio/useAudioUtils';
import { AudioContextWrapper } from '@common/utils/AudioContextWrapper';
import ContentEditable from '@common/ui/EEditorJs/components/ContentEditable.vue';
import Dom from '@common/utils/Dom';
import ApiCommon from '@common/api/apiCommon';
import { AuthRoles } from '@common/interfaces/utils';
import { GrantedActionsEnum } from '@common/enums/grantedActions.enum';
import CEmployeeAvatar from '@common/components/CEmployeeAvatar.vue';
import { ChatStore, CoreStore } from '@common/stores';
import EIcon from '@common/ui/EIcon.vue';
import EButton from '@common/ui/EButton.vue';
import EDropdown from '@common/ui/EDropdown/EDropdown.vue';
import EFileUpload from '@common/ui/EFileUpload/EFileUpload.vue';
import { FileCatalyst } from '@common/utils/Catalyst/FileCatalyst';
import { templateRef, useMounted } from '@vueuse/core';
import { StudentsStore } from '@school/modules/store';
import EMenu from '@common/ui/EMenu/EMenu.vue';
import EMenuItem from '@common/ui/EMenu/EMenuItem.vue';
import EScrollbar from '@common/ui/EScrollbar.vue';
import { nanoid } from 'nanoid';
import MessageService from '@common/ui/EMessage/Message';
import { useChatWebsocket } from '@common/api/ws/hooks/useChatWebsocket';
import { ChatApi } from '@common/api/entities/chat';
import { CatalystURL } from '@common/utils/Catalyst/CatalystURL';
import { FileIdentify } from '@common/utils/Catalyst/FileIdentify';
import { useChatFileUpload } from '@common/hooks/useChatFileUpload';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Chat',
    setup: function (__props) {
        var _this = this;
        var chatApi = new ChatApi();
        var t = useI18n().t;
        var chatScrollerRef = ref();
        var messageInputRef = templateRef('messageInputRef');
        var chatFooterRef = templateRef('chatFooterRef');
        var recordAudioRef = templateRef('recordAudioRef');
        var audioPlayerRef = ref();
        var isMounted = useMounted();
        var input = ref('');
        var timer = ref('');
        var moreMessagesLoading = ref(false);
        var noMoreMessages = ref(false);
        var fileAttachmentDropdownShown = ref(false);
        var savedScrollHeight = ref(null);
        var savedScrollTop = ref(null);
        var selectedMessages = ref([]);
        var editableMessage = ref(null);
        var audioChunk = ref(null);
        var audioAverageFrequency = ref([]);
        var messageState = ref('off');
        var cancelDirectionDistance = ref(0);
        var cancelPercentMove = ref(0);
        var scrollKey = ref(generateUuid());
        var isRecordPlay = computed(function () {
            var _a;
            if (!isMounted.value)
                return false;
            return (_a = audioPlayerRef.value) === null || _a === void 0 ? void 0 : _a.isRecordPlay;
        });
        var isMobileOrTouchable = computed(function () { return isMobile() || isTouchable(); });
        var chat = computed(function () { return ChatStore.contentChat; });
        var chatLoading = computed(function () { return ChatStore.contentChatLoading; });
        var user = computed(function () { return CoreStore.user; });
        var showMenu = ref(false);
        var canSendMessage = computed(function () {
            if (Auth.isStudentUser()
                && chat.value.type === 'channel') {
                return false;
            }
            if (chat.value.type === 'channel') {
                return Auth.hasActions([GrantedActionsEnum.ACTION_SCHOOL_CHAT_WRITE_SCHOOL_CHATS]);
            }
            if (!Auth.isStudentUser() && chat.value.type === 'dialogue' && messages.value.length === 0) {
                return Auth.hasActions([GrantedActionsEnum.ACTION_SCHOOL_CHAT_FIRST_WRITE_STUDENTS]);
            }
            return true;
        });
        var isRecipientTeacher = computed(function () { return chat.value.type === 'dialogue' ? chat.value.recipient.role !== AuthRoles.ROLE_STUDENT : false; });
        var scrollToStart = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!chatScrollerRef.value)
                            return [2 /*return*/];
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        chatScrollerRef.value.scrollToBottom();
                        return [2 /*return*/];
                }
            });
        }); };
        var _a = useChatFileUpload(function () { return chat.value.uuid; }), fileWithTypeList = _a.fileWithTypeList, clearFinishedFiles = _a.clearFinishedFiles, uploadFiles = _a.uploadFiles;
        var messages = computed(function () {
            var e_1, _a;
            var oldMessages = clone(chat.value.messages);
            var messages = [];
            if (oldMessages) {
                try {
                    for (var _b = __values(oldMessages.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var _d = __read(_c.value, 2), index = _d[0], message = _d[1];
                        var prevMessage = oldMessages[index - 1];
                        if (!prevMessage
                            || !dayjs(prevMessage.createdAt).isSame(dayjs(message.createdAt), 'day')) {
                            messages.push({
                                logType: 'date',
                                date: message.createdAt,
                            });
                        }
                        messages.push(__assign(__assign({}, message), { logType: 'message', file: message.file ? new FileCatalyst(new CatalystURL(message.file.url, message.file.name, message.file.size, message.file.mime || 'application/octet-stream'), new FileIdentify(message.file.uuid, message.file.id)) : null }));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return __spreadArray(__spreadArray([], __read(messages), false), __read(fileWithTypeList.value.map(function (f) { return ({
                fileType: f.type,
                logType: 'message',
                createdAt: Date.now(),
                updatedAt: Date.now(),
                id: generateId(),
                text: '',
                user: {
                    id: user.value.id,
                    avatar: user.value.avatar || null,
                    name: user.value.name || '',
                    uuid: user.value.uuid,
                    roles: [],
                },
                file: f.file,
                audio: null,
                isDeleted: false,
                isEdited: false,
            }); })), false).toSorted(function (a, b) {
                if (a.logType === 'date' || b.logType === 'date') {
                    return 0;
                }
                return a.createdAt - b.createdAt;
            });
        });
        watch(chat, function (val, oldVal) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!val) return [3 /*break*/, 2];
                        noMoreMessages.value = false;
                        editableMessage.value = null;
                        selectedMessages.value = [];
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _b.sent();
                        (_a = messageInputRef.value) === null || _a === void 0 ? void 0 : _a.$el.focus();
                        loadDraftMessage(val);
                        if (oldVal && val.id !== oldVal.id) {
                            scrollKey.value = generateUuid();
                            AudioContextWrapper.stopActiveSource();
                            fileWithTypeList.value = [];
                        }
                        scrollToStart();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }, { immediate: true });
        watch(input, function (val) {
            saveDraftMessage(val);
        });
        useChatWebsocket(function () {
            onNewMessageAdded();
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sleep(0)];
                    case 1:
                        _a.sent();
                        cleanInput();
                        cleanMessageSelection();
                        scrollToStart();
                        noMoreMessages.value = false;
                        return [4 /*yield*/, nextTick()];
                    case 2:
                        _a.sent();
                        if (chatFooterRef.value) {
                            cancelDirectionDistance.value = (chatFooterRef.value.clientWidth - 60) / 2;
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        var isSelectedMessage = function (message) {
            return selectedMessages.value.some(function (m) { return m.id === message.id; });
        };
        var toggleMessageSelection = function (message) {
            var hasEditMessagesAction = Auth.hasActions([GrantedActionsEnum.ACTION_SCHOOL_CHAT_WRITE_SCHOOL_CHATS]);
            if (!message.id ||
                (chat.value.type === 'dialogue'
                    && message.user.id !== user.value.id)
                || (chat.value.type !== 'dialogue'
                    && user.value.role === AuthRoles.ROLE_STUDENT
                    && message.user.id !== user.value.id)) {
                return;
            }
            if (chat.value.type === 'channel' && (!Auth.isStudentUser()) && !hasEditMessagesAction) {
                return;
            }
            var isSelected = isSelectedMessage(message);
            if (isSelected) {
                selectedMessages.value = selectedMessages.value.filter(function (m) { return m.id !== message.id; });
            }
            else {
                selectedMessages.value.push(message);
            }
        };
        var cleanMessageSelection = function () {
            selectedMessages.value = [];
        };
        var selectedActionEdit = function () {
            editMessage(selectedMessages.value[0]);
            cleanMessageSelection();
        };
        var saveDraftMessage = function (message) {
            localStorage.setItem("Chat[".concat(chat.value.id, "].message"), message);
        };
        var loadDraftMessage = function (chat) {
            var _a;
            changeInput((_a = localStorage.getItem("Chat[".concat(chat.id, "].message"))) !== null && _a !== void 0 ? _a : '');
        };
        var editMessage = function (message) {
            editableMessage.value = message;
            var messageInput = messageInputRef.value.$el;
            messageInput.innerHTML = message.text.replace(/\r\n|\r|\n/g, '<br />');
            input.value = message.text;
            messageInput.focus();
            setTimeout(function () {
                placeCaretAtEnd(messageInput);
            }, 1);
        };
        var editMessageClose = function () {
            editableMessage.value = null;
            cleanInput();
        };
        var inputClick = function (e) {
            if (!e.target.classList.contains('footer-input__input')) {
                messageInputRef.value.$el.focus();
            }
        };
        var changeInput = function (message) {
            input.value = message;
            if (messageInputRef.value) {
                messageInputRef.value.$el.innerHTML = message;
            }
        };
        var cleanInput = function () {
            changeInput('');
        };
        var onInputKeydown = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (e.keyCode === 13 && !e.shiftKey) {
                    messageFormSubmit();
                    e.preventDefault();
                }
                return [2 /*return*/];
            });
        }); };
        var messageFormSubmit = function () {
            var input = messageInputRef.value.$el;
            var text = input.innerText.trim();
            if (editableMessage.value !== null) {
                saveEditedMessage(text);
            }
            else {
                sendMessage(text);
            }
        };
        var handleImageTypeFiles = function (files) { return __awaiter(_this, void 0, void 0, function () {
            var FILE_TYPE;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        showMenu.value = false;
                        FILE_TYPE = 'image';
                        return [4 /*yield*/, sendFileMessage(FILE_TYPE, files)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var handleFileTypeFiles = function (files) { return __awaiter(_this, void 0, void 0, function () {
            var FILE_TYPE;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        showMenu.value = false;
                        FILE_TYPE = 'file';
                        return [4 /*yield*/, sendFileMessage(FILE_TYPE, files)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var sendFileMessage = function (fileType, files) { return __awaiter(_this, void 0, void 0, function () {
            var chatId, file, uploadedFilePromise, uploadedFile, message, err_1, response, _loop_1, errorKey, state_1, e_2_1;
            var _a, files_1, files_1_1;
            var _b, e_2, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        chatId = chat.value.id;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 11, 12, 17]);
                        _a = true, files_1 = __asyncValues(files);
                        _e.label = 2;
                    case 2: return [4 /*yield*/, files_1.next()];
                    case 3:
                        if (!(files_1_1 = _e.sent(), _b = files_1_1.done, !_b)) return [3 /*break*/, 10];
                        _d = files_1_1.value;
                        _a = false;
                        file = _d;
                        uploadedFilePromise = uploadFiles([{
                                file: file,
                                type: fileType
                            }]);
                        return [4 /*yield*/, scrollToStart()];
                    case 4:
                        _e.sent();
                        return [4 /*yield*/, uploadedFilePromise];
                    case 5:
                        uploadedFile = (_e.sent())[0];
                        _e.label = 6;
                    case 6:
                        _e.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, chatApi.sendMessage(chatId, {
                                message: null,
                                fileType: fileType,
                                file: uploadedFile.uuid,
                            })];
                    case 7:
                        message = (_e.sent()).data;
                        clearFinishedFiles();
                        chat.value.messages.push(message);
                        ChatStore.addChatToList();
                        ChatStore.updateChatLastMessage(chatId, message);
                        // решение в лоб
                        chat.value.messages = chat.value.messages.map(function (e) { return (__assign(__assign({}, e), { isLoading: false })); });
                        return [3 /*break*/, 9];
                    case 8:
                        err_1 = _e.sent();
                        console.error(err_1);
                        response = err_1.response;
                        if (response === null || response === void 0 ? void 0 : response.data) {
                            _loop_1 = function (errorKey) {
                                if (!response.data.hasOwnProperty(errorKey)) {
                                    return { value: void 0 };
                                }
                                var error = response.data[errorKey];
                                setTimeout(function () {
                                    if (errorKey === 'HAS_NO_RIGHTS') {
                                        MessageService.error({
                                            message: t('error.noRights'),
                                            duration: 10000,
                                        });
                                    }
                                    else {
                                        MessageService.error({
                                            message: error.text ? error.text : errorKey,
                                            duration: 10000,
                                        });
                                    }
                                }, 10);
                            };
                            for (errorKey in response.data) {
                                state_1 = _loop_1(errorKey);
                                if (typeof state_1 === "object")
                                    return [2 /*return*/, state_1.value];
                            }
                        }
                        return [3 /*break*/, 9];
                    case 9:
                        _a = true;
                        return [3 /*break*/, 2];
                    case 10: return [3 /*break*/, 17];
                    case 11:
                        e_2_1 = _e.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 17];
                    case 12:
                        _e.trys.push([12, , 15, 16]);
                        if (!(!_a && !_b && (_c = files_1.return))) return [3 /*break*/, 14];
                        return [4 /*yield*/, _c.call(files_1)];
                    case 13:
                        _e.sent();
                        _e.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        if (e_2) throw e_2.error;
                        return [7 /*endfinally*/];
                    case 16: return [7 /*endfinally*/];
                    case 17: return [2 /*return*/];
                }
            });
        }); };
        var onPaste = function (e) {
            var e_3, _a;
            var clipboardData = (e.clipboardData || window.clipboardData);
            var file;
            for (var index in clipboardData.items) {
                if (!clipboardData.items.hasOwnProperty(index))
                    continue;
                var item = clipboardData.items[index];
                if (item.kind === 'file') {
                    file = item.getAsFile();
                }
            }
            // Если картинка, отправляем файл, нет - добавляем текст
            if (file && file.type.split('/')[0] === 'image') {
                sendFileMessage('image', [new FileCatalyst(file)]);
            }
            else {
                var pasteText = clipboardData.getData('text');
                var selection = window.getSelection();
                if (!selection.rangeCount)
                    return false;
                selection.deleteFromDocument();
                var content = Dom.stringToDom(pasteText.replace(/\r\n|\r|\n/g, '<br />'));
                try {
                    for (var _b = __values(__spreadArray([], __read(content.body.childNodes), false).reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var node = _c.value;
                        selection.getRangeAt(0).insertNode(node);
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                selection.collapseToEnd();
                input.value = messageInputRef.value.$el.innerText;
            }
            e.preventDefault();
        };
        var sendMessage = function (text) {
            if (text.length === 0) {
                MessageService.error(t('error.emptyMessage'));
                return;
            }
            var chatId = chat.value.id;
            var tempMessage = {
                'tempId': nanoid(),
                'user': clone(user.value),
                'createdAt': Date.now(),
                'updatedAt': Date.now(),
                'isEdited': false,
                'isDeleted': false,
                'isLoading': true,
                'text': text,
            };
            if (!chat.value.messages)
                chat.value.messages = [];
            chat.value.messages.push(tempMessage);
            ChatStore.addChatToList();
            ChatStore.updateChatLastMessage(chatId, tempMessage);
            chatApi.sendMessage(chatId, {
                message: text,
                fileType: null,
                file: null,
            })
                .then(function (res) {
                var data = res.data, message = data;
                selectedMessages.value = selectedMessages.value.map(function (m) {
                    if (m.tempId && m.tempId === tempMessage.tempId) {
                        return message;
                    }
                    return m;
                });
                chat.value.messages = chat.value.messages.map(function (m) {
                    if (m.tempId && m.tempId === tempMessage.tempId) {
                        return message;
                    }
                    return m;
                });
                if (chat.value.lastMessage.tempId === tempMessage.tempId) {
                    ChatStore.updateChatLastMessage(chat.value.id, message);
                }
                // решение в лоб
                chat.value.messages = chat.value.messages.map(function (e) { return (__assign(__assign({}, e), { isLoading: false })); });
            })
                .catch(function (err) {
                var response = err.response;
                var data = response.data;
                if (data) {
                    var _loop_2 = function (errorKey) {
                        if (!data.hasOwnProperty(errorKey)) {
                            return { value: void 0 };
                        }
                        var error = data[errorKey];
                        setTimeout(function () {
                            if (errorKey === 'HAS_NO_RIGHTS') {
                                MessageService.error({
                                    message: t('error.noRights'),
                                    duration: 10000,
                                });
                            }
                            else {
                                MessageService.error({
                                    message: error.text ? error.text : errorKey,
                                    duration: 10000,
                                });
                            }
                        }, 10);
                    };
                    for (var errorKey in data) {
                        var state_2 = _loop_2(errorKey);
                        if (typeof state_2 === "object")
                            return state_2.value;
                    }
                }
            });
            scrollToStart();
            changeInput('');
        };
        var saveEditedMessage = function (text) {
            var message = editableMessage.value;
            chat.value.messages = chat.value.messages.map(function (m) {
                if (m.id === message.id) {
                    message.text = text;
                    message.updatedAt = Date.now();
                    return message;
                }
                return m;
            });
            ChatStore.chats = ChatStore.chats.map(function (c) {
                if (c.id === chat.value.id
                    && c.lastMessage.id === message.id) {
                    c.lastMessage = message;
                }
                return c;
            });
            editMessageClose();
            cleanInput();
            ApiCommon.editChatMessage(chat.value.id, message.id, { text: text })
                .then(function (res) {
                var data = res.data, result = data;
                chat.value.messages = chat.value.messages.map(function (m) {
                    if (m.id === result.id) {
                        return result;
                    }
                    return m;
                });
            });
        };
        var deleteMessages = function () {
            var messages = selectedMessages.value;
            var chatId = chat.value.id;
            chat.value.messages = chat.value.messages.filter(function (message) {
                return !messages.some(function (m) { return m.id === message.id; });
            });
            var messageIds = selectedMessages.value.map(function (m) {
                return m.id;
            });
            chat.value.lastMessage = chat.value.messages[chat.value.messages.length - 1];
            ApiCommon.deleteChatMessages(chatId, messageIds);
            cleanMessageSelection();
        };
        var loadMoreMessages = function () {
            if (noMoreMessages.value)
                return;
            var messageCount = chat.value.messages.length, chatId = chat.value.id;
            moreMessagesLoading.value = true;
            chatApi.getOffsetMessages(chatId, messageCount)
                .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                var data, result, newMessages;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            data = res.data, result = data;
                            scrollSave();
                            newMessages = result.messages;
                            moreMessagesLoading.value = false;
                            (_a = chat.value.messages).unshift.apply(_a, __spreadArray([], __read(newMessages.toReversed()), false));
                            if (result.noMore) {
                                noMoreMessages.value = true;
                            }
                            return [4 /*yield*/, nextTick()];
                        case 1:
                            _b.sent();
                            scrollToSaved();
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        var onNewMessageAdded = function () {
            if (!chatScrollerRef.value)
                return;
            var _a = chatScrollerRef.value.$el, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, offsetHeight = _a.offsetHeight, offset = 100;
            if (scrollTop + offsetHeight + offset > scrollHeight) {
                scrollToStart();
            }
        };
        var onChatScroll = function (e) {
            var el = e.target, height = el.offsetHeight, scrollHeight = el.scrollHeight, scrollTop = el.scrollTop, offset = 400, localChat = chat.value;
            if (localChat.unreadMessages
                && height + scrollTop + offset > scrollHeight) {
                localChat.unreadMessages = 0;
                localChat.unreadSince = null;
                ApiCommon.markChatRead(localChat.id);
            }
            /**
             * Load more
             */
            if (!(moreMessagesLoading.value || noMoreMessages.value)
                && scrollHeight > height + offset
                && scrollTop < offset) {
                loadMoreMessages();
            }
        };
        var scrollSave = function () {
            var _a, _b;
            savedScrollHeight.value = (_a = chatScrollerRef.value) === null || _a === void 0 ? void 0 : _a.$el.scrollHeight;
            savedScrollTop.value = (_b = chatScrollerRef.value) === null || _b === void 0 ? void 0 : _b.$el.scrollTop;
        };
        var scrollToSaved = function () {
            var _a;
            chatScrollerRef.value.$el.scrollTop = ((_a = chatScrollerRef.value) === null || _a === void 0 ? void 0 : _a.$el.scrollHeight) - savedScrollHeight.value + savedScrollTop.value;
        };
        var goRecipients = function () {
            if (!Auth.isStudentUser() && !Auth.hasActions([GrantedActionsEnum.ACTION_SCHOOL_CHAT_STUDENT_LIST]))
                return;
            ChatStore.openChatRecipientsPage();
        };
        var goList = function () {
            ChatStore.openChatList();
        };
        var getDateFormatted = function (date) {
            var now = dayjs(Date.now()).startOf('day'), messageTime = dayjs(date).startOf('day'), differentDays = now.diff(messageTime, 'days'), differentHours = now.diff(messageTime, 'hours');
            if (differentDays === 0) {
                return t('date.today');
            }
            else if (differentDays < 2) {
                return t('date.yesterday');
            }
            else {
                return messageTime.format('DD MMMM');
            }
        };
        var recipientClicked = function () {
            if (chat.value.type !== 'dialogue' ||
                Auth.isStudentUser() ||
                chat.value.recipient.id === user.value.id ||
                isRecipientTeacher.value) {
                return;
            }
            StudentsStore.showStudentProfile(chat.value.recipient.id);
        };
        var handleTimer = function ($event) {
            timer.value = $event;
        };
        var handleStartRecord = function () {
            cancelPercentMove.value = 0;
            if (messageState.value !== 'hold') {
                messageState.value = 'record';
            }
        };
        var handleStopRecord = function (audioChunkProp, byStop, averageFrequencyProp) {
            cancelPercentMove.value = 0;
            if (byStop === RecordAudioStopByEnum.TOOLTIP_CANCEL) {
                messageState.value = 'showTrack';
                audioChunk.value = audioChunkProp;
                audioAverageFrequency.value = averageFrequencyProp;
            }
            else {
                messageState.value = 'off';
            }
        };
        var handleSendAudio = function (audioChunk, averageFrequency) { return __awaiter(_this, void 0, void 0, function () {
            var audioUtils, blob, audioBuffer, filename, audioFile, tempMessage_1, data_1, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        messageState.value = 'off';
                        cancelPercentMove.value = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        audioUtils = useAudioUtils();
                        blob = audioChunk;
                        return [4 /*yield*/, audioUtils.blobToAudioBuffer(blob)];
                    case 2:
                        audioBuffer = _a.sent();
                        filename = "".concat(generateUuid(), ".wav");
                        audioFile = new File([blob], filename);
                        tempMessage_1 = {
                            tempId: nanoid(),
                            user: clone(user.value),
                            createdAt: Date.now(),
                            updatedAt: Date.now(),
                            isEdited: false,
                            isDeleted: false,
                            isLoading: true,
                            text: null,
                            audio: {
                                audioAverageFrequency: averageFrequency,
                                audioTime: audioBuffer.duration,
                                chunked: false,
                                id: nanoid(),
                                name: audioFile.name,
                                size: audioFile.size,
                                type: 'audio',
                                uuid: generateUuid(),
                                url: blob,
                            },
                        };
                        chat.value.messages.push(tempMessage_1);
                        ChatStore.addChatToList();
                        ChatStore.updateChatLastMessage(chat.value.id, tempMessage_1);
                        scrollToStart();
                        return [4 /*yield*/, chatApi.sendMessage(chat.value.id, {
                                audio: audioFile,
                                time: audioBuffer.duration.toFixed(2),
                                averageFrequency: averageFrequency,
                            })];
                    case 3:
                        data_1 = (_a.sent()).data;
                        selectedMessages.value = selectedMessages.value.map(function (m) {
                            if (m.tempId && m.tempId === tempMessage_1.tempId) {
                                return data_1;
                            }
                            return m;
                        });
                        chat.value.messages = chat.value.messages.map(function (m) {
                            if (m.tempId && m.tempId === tempMessage_1.tempId) {
                                return data_1;
                            }
                            return m;
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        apiErrorsHandle(err_2, {});
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var handleCancelRecord = function () {
            var recordRef = recordAudioRef.value;
            recordRef.manualStop('MANUAL_0', false, true);
            messageState.value = 'off';
            cancelPercentMove.value = 0;
        };
        var handleChangeRetention = function (retantion) {
            if (retantion) {
                messageState.value = 'hold';
            }
        };
        var handleDeleteTrack = function () {
            var recordRef = recordAudioRef.value;
            recordRef.manualStop('MANUAL_1', false, true);
            messageState.value = 'off';
            audioChunk.value = null;
        };
        var handleCancelPercentMove = function (movePercent) {
            cancelPercentMove.value = movePercent;
        };
        var play = function () {
            var _a;
            (_a = audioPlayerRef.value) === null || _a === void 0 ? void 0 : _a.toggleRecord();
        };
        //Плюрализм
        return function (_ctx, _cache) {
            var _a, _b;
            var _directive_loading = _resolveDirective("loading");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", {
                            class: _normalizeClass([!isMobileOrTouchable.value ? 'lg:hidden' : '', "flex mb-1 shrink-0 items-center py-2 font-medium text-gray-400 transition-colors cursor-pointer m hover:text-primary-300"]),
                            onClick: goList
                        }, [
                            _createVNode(EIcon, {
                                class: "mr-1 w-2 h-4",
                                icon: "angle-left"
                            }),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('chat.list')), 1)
                        ], 2),
                        _createElementVNode("div", {
                            class: _normalizeClass([selectedMessages.value.length > 0 ? 'hidden sm:flex' : '', "flex items-center"])
                        }, [
                            (chat.value.type === 'dialogue' && chat.value.recipient)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (isRecipientTeacher.value)
                                        ? (_openBlock(), _createBlock(CEmployeeAvatar, {
                                            key: 0,
                                            name: chat.value.recipient.name ? chat.value.recipient.name : (_a = chat.value.recipient.email) !== null && _a !== void 0 ? _a : '',
                                            src: chat.value.avatar,
                                            uuid: chat.value.recipient.uuid,
                                            class: "!h-10 !w-10 mr-2.5"
                                        }, null, 8, ["name", "src", "uuid"]))
                                        : (_openBlock(), _createBlock(Avatar, {
                                            key: 1,
                                            class: _normalizeClass([[
                                                    !_unref(Auth).isStudentUser() ? 'cursor-pointer' : ''
                                                ], "header-info__avatar"]),
                                            "color-id": chat.value.recipient.id,
                                            name: chat.value.recipient.name ? chat.value.recipient.name : (_b = chat.value.recipient.email) !== null && _b !== void 0 ? _b : '',
                                            src: chat.value.avatar,
                                            onClick: recipientClicked
                                        }, null, 8, ["class", "color-id", "name", "src"]))
                                ], 64))
                                : (_openBlock(), _createBlock(Avatar, {
                                    key: 1,
                                    src: chat.value.avatar,
                                    class: "header-info__avatar"
                                }, null, 8, ["src"])),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    (chat.value.type === 'channel')
                                        ? (_openBlock(), _createBlock(EIcon, {
                                            key: 0,
                                            class: "shrink-0 mr-2 w-4 h-4 text-gray-300",
                                            icon: "advertising"
                                        }))
                                        : (chat.value.type === 'group')
                                            ? (_openBlock(), _createBlock(EIcon, {
                                                key: 1,
                                                class: "shrink-0 mr-2 w-4 h-4 text-gray-300",
                                                icon: "multiple-users"
                                            }))
                                            : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_7, [
                                        (chat.value.name)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(chat.value.name), 1)
                                            ], 64))
                                            : (chat.value.type === 'dialogue')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createTextVNode(_toDisplayString(chat.value.recipient.email), 1)
                                                ], 64))
                                                : _createCommentVNode("", true)
                                    ])
                                ]),
                                (chat.value.type === 'dialogue')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (chat.value.recipient.lastActiveDate > 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(t)('chat.lastOnline', { time: _unref(formatOnline)(chat.value.recipient.lastActiveDate) })), 1))
                                            : _createCommentVNode("", true)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock("p", {
                                        key: 1,
                                        class: _normalizeClass([[
                                                !_unref(Auth).isStudentUser() && !_unref(Auth).hasActions([_unref(GrantedActionsEnum).ACTION_SCHOOL_CHAT_STUDENT_LIST]) ? '!cursor-default hover:!no-underline' : ''
                                            ], "header-info__subtitle"]),
                                        onClick: goRecipients
                                    }, _toDisplayString(_unref(t)('chat.participants', chat.value.recipients.length)), 3))
                            ])
                        ], 2)
                    ]),
                    (selectedMessages.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (selectedMessages.value.length === 1 && !selectedMessages.value.some(function (e) { return e.file; }))
                                ? (_openBlock(), _createBlock(EButton, {
                                    key: 0,
                                    size: "small",
                                    type: "secondary",
                                    onClick: selectedActionEdit
                                }, {
                                    default: _withCtx(function () { return [
                                        _createTextVNode(_toDisplayString(_unref(t)('chat.edit')), 1)
                                    ]; }),
                                    _: 1
                                }))
                                : _createCommentVNode("", true),
                            _createVNode(EButton, {
                                class: "ml-2",
                                size: "small",
                                type: "danger",
                                onClick: deleteMessages
                            }, {
                                default: _withCtx(function () { return [
                                    _createTextVNode(_toDisplayString(_unref(t)('chat.delete')), 1)
                                ]; }),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_openBlock(), _createBlock(EScrollbar, {
                    key: scrollKey.value,
                    ref_key: "chatScrollerRef",
                    ref: chatScrollerRef,
                    options: { suppressScrollX: true },
                    class: "chat-content",
                    onPsScrollY: onChatScroll
                }, {
                    default: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                                [_directive_loading, moreMessagesLoading.value]
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, function (message) {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: message.id
                                }, [
                                    (message.logType === 'date')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("span", _hoisted_13, _toDisplayString(getDateFormatted(message.date)), 1)
                                        ]))
                                        : (message.logType === 'message')
                                            ? (_openBlock(), _createBlock(Message, {
                                                key: 1,
                                                message: message,
                                                selected: isSelectedMessage(message),
                                                onClick: function ($event) { return (toggleMessageSelection(message)); }
                                            }, null, 8, ["message", "selected", "onClick"]))
                                            : _createCommentVNode("", true)
                                ], 64));
                            }), 128))
                        ])
                    ]; }),
                    _: 1
                })),
                (editableMessage.value !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("p", {
                                class: "chat-editable-message__message",
                                textContent: _toDisplayString(editableMessage.value.text)
                            }, null, 8, _hoisted_17)
                        ]),
                        _createElementVNode("div", {
                            class: "chat-editable-message__closer",
                            onClick: editMessageClose
                        }, [
                            _createVNode(EIcon, {
                                class: "w-5 h-5",
                                icon: "close"
                            })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (canSendMessage.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        ref_key: "chatFooterRef",
                        ref: chatFooterRef,
                        class: "chat-footer"
                    }, [
                        _withDirectives(_createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                                _createVNode(EDropdown, {
                                    visible: showMenu.value,
                                    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) { return ((showMenu).value = $event); }),
                                    class: "h-full",
                                    trigger: "click"
                                }, {
                                    overlay: _withCtx(function () { return [
                                        _createVNode(EMenu, null, {
                                            default: _withCtx(function () { return [
                                                _createVNode(EFileUpload, {
                                                    multiple: "",
                                                    onChange: handleFileTypeFiles
                                                }, {
                                                    default: _withCtx(function (_a) {
                                                        var open = _a.open;
                                                        return [
                                                            _createVNode(EMenuItem, { onSelect: open }, {
                                                                default: _withCtx(function () { return [
                                                                    _createElementVNode("div", _hoisted_20, [
                                                                        _createVNode(EIcon, {
                                                                            class: "opacity-60 w-5 h-5",
                                                                            icon: "paper"
                                                                        }),
                                                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('chat.file')), 1)
                                                                    ])
                                                                ]; }),
                                                                _: 2
                                                            }, 1032, ["onSelect"])
                                                        ];
                                                    }),
                                                    _: 1
                                                }),
                                                _createVNode(EFileUpload, {
                                                    accept: "image/*",
                                                    multiple: "",
                                                    onChange: handleImageTypeFiles
                                                }, {
                                                    default: _withCtx(function (_a) {
                                                        var open = _a.open;
                                                        return [
                                                            _createVNode(EMenuItem, { onSelect: open }, {
                                                                default: _withCtx(function () { return [
                                                                    _createElementVNode("div", _hoisted_21, [
                                                                        _createVNode(EIcon, {
                                                                            class: "opacity-60 w-5 h-5",
                                                                            icon: "image"
                                                                        }),
                                                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('chat.image')), 1)
                                                                    ])
                                                                ]; }),
                                                                _: 2
                                                            }, 1032, ["onSelect"])
                                                        ];
                                                    }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        })
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        (_unref(isMobile)())
                                            ? (_openBlock(), _createBlock(EButton, {
                                                key: 0,
                                                class: "footer-attach__button",
                                                type: "text"
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(EIcon, {
                                                        class: "w-5 h-5",
                                                        icon: "attach"
                                                    })
                                                ]; }),
                                                _: 1
                                            }))
                                            : (_openBlock(), _createBlock(EFileUpload, {
                                                key: 1,
                                                disabled: _unref(isMobile)(),
                                                class: "h-full",
                                                multiple: "",
                                                onChange: handleFileTypeFiles
                                            }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(EButton, {
                                                        class: "footer-attach__button",
                                                        type: "text"
                                                    }, {
                                                        default: _withCtx(function () { return [
                                                            _createVNode(EIcon, {
                                                                class: "w-5 h-5",
                                                                icon: "attach"
                                                            })
                                                        ]; }),
                                                        _: 1
                                                    })
                                                ]; }),
                                                _: 1
                                            }, 8, ["disabled"]))
                                    ]; }),
                                    _: 1
                                }, 8, ["visible"])
                            ]),
                            _createVNode(EScrollbar, {
                                ref: "inputScroller",
                                class: "chat-footer__input my-2 grow",
                                onClick: inputClick
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("div", _hoisted_22, [
                                        _createVNode(ContentEditable, {
                                            ref_key: "messageInputRef",
                                            ref: messageInputRef,
                                            modelValue: input.value,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((input).value = $event); }),
                                            class: "footer-input__input",
                                            onKeydown: onInputKeydown,
                                            onPaste: _withModifiers(onPaste, ["prevent"])
                                        }, null, 8, ["modelValue"]),
                                        (input.value.length === 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(t)('chat.writeMessage')), 1))
                                            : _createCommentVNode("", true)
                                    ])
                                ]; }),
                                _: 1
                            }, 512)
                        ], 512), [
                            [_vShow, messageState.value === 'off']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("span", _hoisted_27, _toDisplayString(timer.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", {
                                    style: _normalizeStyle({ opacity: (100 - cancelPercentMove.value) / 100, left: "".concat(50 - (cancelPercentMove.value / 4) > 50 ? 50 : 50 - (cancelPercentMove.value / 4), "%") }),
                                    class: "whitespace-nowrap absolute -translate-x-2/4 -translate-y-2/4 left-2/4 top-2/4"
                                }, _toDisplayString(_unref(t)('chat.cancelHint')), 5)
                            ])
                        ], 512), [
                            [_vShow, messageState.value === 'record']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("span", _hoisted_32, _toDisplayString(timer.value), 1)
                            ]),
                            _createElementVNode("div", _hoisted_33, [
                                _createVNode(EButton, {
                                    class: "record-cancel",
                                    size: "nosize",
                                    type: "text",
                                    onClick: handleCancelRecord
                                }, {
                                    default: _withCtx(function () { return [
                                        _createTextVNode(_toDisplayString(_unref(t)('chat.cancelRecording')), 1)
                                    ]; }),
                                    _: 1
                                })
                            ])
                        ], 512), [
                            [_vShow, messageState.value === 'hold']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createVNode(EButton, {
                                    class: "text-[#4D57664D] hover:text-[#FF7575] transition-colors",
                                    size: "nosize",
                                    type: "text",
                                    onClick: handleDeleteTrack
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(EIcon, {
                                            class: "w-[15px] h-[18px]",
                                            icon: "trash-reverse"
                                        })
                                    ]; }),
                                    _: 1
                                })
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                    (audioChunk.value)
                                        ? (_openBlock(), _createBlock(EButton, {
                                            key: 0,
                                            class: "pause-play-wrapper",
                                            size: "nosize",
                                            type: "text",
                                            onClick: play
                                        }, {
                                            default: _withCtx(function () { return [
                                                (isRecordPlay.value)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _hoisted_38,
                                                        _hoisted_39
                                                    ], 64))
                                                    : (_openBlock(), _createBlock(EIcon, {
                                                        key: 1,
                                                        class: "w-[11px] h-[11px] text-white ml-0.5",
                                                        icon: "play-button-arrowhead"
                                                    }))
                                            ]; }),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true),
                                    (audioChunk.value)
                                        ? (_openBlock(), _createBlock(EAudioPlayer, {
                                            key: 1,
                                            ref_key: "audioPlayerRef",
                                            ref: audioPlayerRef,
                                            audio: audioChunk.value,
                                            "average-frequency": audioAverageFrequency.value,
                                            class: "flex-[1] mx-2.5 h-full flex items-center w-full"
                                        }, null, 8, ["audio", "average-frequency"]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(timer.value), 1)
                                ])
                            ])
                        ], 512), [
                            [_vShow, messageState.value === 'showTrack']
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                            (input.value.length === 0)
                                ? (_openBlock(), _createBlock(ERecordAudioController, {
                                    key: 0,
                                    ref_key: "recordAudioRef",
                                    ref: recordAudioRef,
                                    "cancel-direction-distance": cancelDirectionDistance.value,
                                    "cancel-direction": "left",
                                    onCancelPercentMove: handleCancelPercentMove,
                                    onChangeRetention: handleChangeRetention,
                                    onSend: handleSendAudio,
                                    onStart: handleStartRecord,
                                    onStop: handleStopRecord,
                                    onTimer: handleTimer
                                }, null, 8, ["cancel-direction-distance"]))
                                : (_openBlock(), _createBlock(EButton, {
                                    key: 1,
                                    disabled: input.value.length === 0,
                                    class: "chat-footer__send-message",
                                    type: "text",
                                    onClick: messageFormSubmit
                                }, {
                                    default: _withCtx(function () { return [
                                        _createVNode(EIcon, {
                                            class: "w-5 h-5",
                                            icon: "send"
                                        })
                                    ]; }),
                                    _: 1
                                }, 8, ["disabled"]))
                        ])
                    ], 512))
                    : _createCommentVNode("", true)
            ])), [
                [_directive_loading, chatLoading.value]
            ]);
        };
    }
});
